import { isBooleanFalse, isBooleanTrue, isListNotEmpty, isNotNullOrUndefined, isNumberNotEmpty, isObjectNotEmpty, isStringEmpty, isStringNotEmpty, isStringNotEmptyOrZeroLength, removeEmptyAndNull } from "../utils/objectUtils";
import { create, getAll, getBySingleQuery, remove, update, updateField, updateFields } from '../utils/dbUtils';
import { collection, endBefore, getCountFromServer, getDocs, limit, limitToLast, orderBy, query, startAfter, Timestamp, where } from 'firebase/firestore';
import { db } from '../firebase';
import { asTimeZone, fromUtcToDate } from "../utils/dateFormatter";
import moment from 'moment-timezone';
import { orderBy as lodashOrderBy, toLower } from "lodash";
import LogRocket from "logrocket";
import ROUTES from "../constants/routes";
import Notification from "./Notification";
import { sendFCMMessage } from "../firebase/Messaging";
import logger from "../utils/logger";
import { getTestModeConsole } from "../utils/testMode";
import { sanitizeTrackProperties } from "../utils/logRocketUtils";
import { getQueryParam } from "../utils/clientUtils";

class SiteEvent {
    static collectionName = 'siteEvents';

    funnel = null;
    stepName = null;
    stepNumber = null;
    direction = null;
    eventName = null;
    pathName = null;

    offerId = null;
    affId = null;
    sub1 = null;
    sub2 = null;
    sub3 = null;
    sub4 = null;
    sub5 = null;
    uId = null;
    sourceId = null;
    transactionId = null;
    source = null;
    affiliateId = null;
    subAffiliateId = null;
    campaignId = null;
    programId = null;
    version = null;
    creativeId = null;
    clickId = null;
    ipAddress = null;
    userAgent = null;
    referrerUrl = null;
    // the rrx_visitor_id cookie, which outlives any single visit and links a visitor's sessions
    visitorId = null;
    // the marketing alias of the page the visit landed on - url keeps the real path
    landingRouteAlias = null;
    userId = null;
    leadId = null;

    shippingState = null;
    gender = null;
    dateOfBirth = null;
    bmi = 0;

    couponCode = null;

    siteVisitId = null;

    testMode = false;

    url = null;

    fbclid = null;
    fbc = null;
    ttclid = null;
    gclid = null;
    irclickid = null;
    rdt_cid = null;
    SsCid = null;
    msclkid = null;
    twclid = null;
    nbclid = null;
    gbraid = null;
    wbraid = null;

    utm_source = null;
    utm_campaign = null;
    utm_content = null;
    utm_medium = null;
    utm_term = null;

    productSku = null;
    offerGroupId = null;
    offerToken = null;
    addon = false;
    deviceFingerprint = null;
    amount = 0;

    funnelType = null;
    funnelKey = null;
    funnelVersion = null;
    funnelConfigId = null;
    experimentId = null;
    variantId = null;
    assignmentKey = null;

    eventKey = null;
    eventCategory = null;
    stageKey = null;
    stepKey = null;
    stepType = null;
    displayOrder = null;

    sessionKey = null;
    encounterId = null;
    subscriptionId = null;
    orderId = null;

    surveyId = null;
    surveySlug = null;
    surveyStepId = null;
    surveyStepKey = null;
    questionIds = [];
    branchPath = [];
    conditionalVisibility = null;

    result = null;
    blockerCode = null;
    dataQuality = 'OBSERVED';

    entryProductSku = null;
    entryOfferGroupId = null;
    entryOfferToken = null;
    firstProductSkuSelected = null;
    firstOfferGroupIdSelected = null;
    firstOfferTokenSelected = null;
    finalProductSkuSelected = null;
    finalOfferGroupIdSelected = null;
    finalOfferTokenSelected = null;
    checkoutProductSku = null;
    checkoutOfferGroupId = null;
    checkoutOfferToken = null;

    isExistingCustomer = false;
    phoneVerificationRequired = false;
    governmentIdRequired = false;
    governmentIdReused = false;
    identityConfirmationRequired = false;

    occurredAt = null;
    perfNowMs = null;

    constructor(siteEvent) {
        if (isObjectNotEmpty(siteEvent)) {
            if (isStringNotEmpty(siteEvent.funnel)) { this.funnel = siteEvent.funnel; }
            if (isNumberNotEmpty(siteEvent.stepNumber) || isStringNotEmpty(siteEvent.stepNumber)) { this.stepNumber = siteEvent.stepNumber; }
            if (isStringNotEmpty(siteEvent.stepName)) { this.stepName = siteEvent.stepName; }
            if (isStringNotEmpty(siteEvent.direction)) { this.direction = siteEvent.direction; }
            if (isStringNotEmpty(siteEvent.eventName)) { this.eventName = siteEvent.eventName; }
            else if (isStringNotEmpty(siteEvent.event)) { this.eventName = siteEvent.event; }
            if (isStringNotEmpty(siteEvent.pathName)) { this.pathName = siteEvent.pathName; }

            if (isStringNotEmpty(siteEvent.offerId)) { this.offerId = siteEvent.offerId; }
            if (isStringNotEmpty(siteEvent.affId)) { this.affId = siteEvent.affId; }
            if (isStringNotEmpty(siteEvent.sub1)) { this.sub1 = siteEvent.sub1; }
            if (isStringNotEmpty(siteEvent.sub2)) { this.sub2 = siteEvent.sub2; }
            if (isStringNotEmpty(siteEvent.sub3)) { this.sub3 = siteEvent.sub3; }
            if (isStringNotEmpty(siteEvent.sub4)) { this.sub4 = siteEvent.sub4; }
            if (isStringNotEmpty(siteEvent.sub5)) { this.sub5 = siteEvent.sub5; }
            if (isStringNotEmpty(siteEvent.uId)) { this.uId = siteEvent.uId; }
            if (isStringNotEmpty(siteEvent.sourceId)) { this.sourceId = siteEvent.sourceId; }
            if (isStringNotEmpty(siteEvent.transactionId)) { this.transactionId = siteEvent.transactionId; }
            if (isStringNotEmpty(siteEvent.source)) { this.source = siteEvent.source; }
            if (isStringNotEmpty(siteEvent.affiliateId)) { this.affiliateId = toLower(siteEvent.affiliateId); }
            if (isStringNotEmpty(siteEvent.subAffiliateId)) { this.subAffiliateId = toLower(siteEvent.subAffiliateId); }
            if (isStringNotEmpty(siteEvent.campaignId)) { this.campaignId = siteEvent.campaignId; }
            if (isStringNotEmpty(siteEvent.programId)) { this.programId = siteEvent.programId; }
            if (isStringNotEmpty(siteEvent.version)) { this.version = toLower(siteEvent.version); }
            if (isStringNotEmpty(siteEvent.creativeId)) { this.creativeId = toLower(siteEvent.creativeId); }
            if (isStringNotEmpty(siteEvent.clickId)) { this.clickId = siteEvent.clickId; }
            if (isStringNotEmpty(siteEvent.ipAddress)) { this.ipAddress = siteEvent.ipAddress; }
            if (isStringNotEmpty(siteEvent.userAgent)) { this.userAgent = siteEvent.userAgent; }
            if (isStringNotEmpty(siteEvent.referrerUrl)) { this.referrerUrl = siteEvent.referrerUrl; }
            if (isStringNotEmpty(siteEvent.visitorId)) { this.visitorId = siteEvent.visitorId; }
            if (isStringNotEmpty(siteEvent.landingRouteAlias)) { this.landingRouteAlias = siteEvent.landingRouteAlias; }
            if (isStringNotEmpty(siteEvent.userId)) { this.userId = siteEvent.userId; }
            if (isStringNotEmpty(siteEvent.leadId)) { this.leadId = siteEvent.leadId; }

            if (isStringNotEmpty(siteEvent.shippingState)) { this.shippingState = siteEvent.shippingState; }
            if (isStringNotEmpty(siteEvent.gender)) { this.gender = siteEvent.gender; }
            if (isStringNotEmpty(siteEvent.dateOfBirth)) { this.dateOfBirth = siteEvent.dateOfBirth; }
            if (isNumberNotEmpty(siteEvent.bmi)) { this.bmi = siteEvent.bmi; }

            if (isStringNotEmpty(siteEvent.couponCode)) { this.couponCode = siteEvent.couponCode; }

            if (isStringNotEmpty(siteEvent.siteVisitId)) { this.siteVisitId = siteEvent.siteVisitId; }

            if (isBooleanTrue(siteEvent.testMode)) { this.testMode = true; }

            if (isStringNotEmpty(siteEvent.url)) { this.url = siteEvent.url; }

            if (isStringNotEmpty(siteEvent.fbclid)) { this.fbclid = siteEvent.fbclid; }
            if (isStringNotEmpty(siteEvent.fbc)) { this.fbc = siteEvent.fbc; }
            if (isStringNotEmpty(siteEvent.ttclid)) { this.ttclid = siteEvent.ttclid; }
            if (isStringNotEmpty(siteEvent.gclid)) { this.gclid = siteEvent.gclid; }
            if (isStringNotEmpty(siteEvent.irclickid)) { this.irclickid = siteEvent.irclickid; }
            if (isStringNotEmpty(siteEvent.rdt_cid)) { this.rdt_cid = siteEvent.rdt_cid; }
            if (isStringNotEmpty(siteEvent.SsCid)) { this.SsCid = siteEvent.SsCid; }
            if (isStringNotEmpty(siteEvent.msclkid)) { this.msclkid = siteEvent.msclkid; }
            if (isStringNotEmpty(siteEvent.twclid)) { this.twclid = siteEvent.twclid; }
            if (isStringNotEmpty(siteEvent.nbclid)) { this.nbclid = siteEvent.nbclid; }
            if (isStringNotEmpty(siteEvent.gbraid)) { this.gbraid = siteEvent.gbraid; }
            if (isStringNotEmpty(siteEvent.wbraid)) { this.wbraid = siteEvent.wbraid; }

            if (isStringNotEmpty(siteEvent.utm_source)) { this.utm_source = siteEvent.utm_source; }
            if (isStringNotEmpty(siteEvent.utm_campaign)) { this.utm_campaign = siteEvent.utm_campaign; }
            if (isStringNotEmpty(siteEvent.utm_content)) { this.utm_content = siteEvent.utm_content; }
            if (isStringNotEmpty(siteEvent.utm_medium)) { this.utm_medium = siteEvent.utm_medium; }
            if (isStringNotEmpty(siteEvent.utm_term)) { this.utm_term = siteEvent.utm_term; }

            if (isStringNotEmpty(siteEvent.productSku)) { this.productSku = siteEvent.productSku; }
            if (isStringNotEmpty(siteEvent.offerGroupId)) { this.offerGroupId = siteEvent.offerGroupId; }
            if (isStringNotEmpty(siteEvent.offerToken)) { this.offerToken = siteEvent.offerToken; }
            if (isBooleanTrue(siteEvent.addon)) { this.addon = true; }
            if (isStringNotEmpty(siteEvent.deviceFingerprint)) { this.deviceFingerprint = siteEvent.deviceFingerprint; }
            if (isNumberNotEmpty(siteEvent.amount)) { this.amount = siteEvent.amount; }

            if (isStringNotEmpty(siteEvent.funnelType)) { this.funnelType = siteEvent.funnelType; }
            if (isStringNotEmpty(siteEvent.funnelKey)) { this.funnelKey = siteEvent.funnelKey; }
            if (isStringNotEmpty(siteEvent.funnelVersion)) { this.funnelVersion = siteEvent.funnelVersion; }
            if (isStringNotEmpty(siteEvent.funnelConfigId)) { this.funnelConfigId = siteEvent.funnelConfigId; }
            if (isStringNotEmpty(siteEvent.experimentId)) { this.experimentId = siteEvent.experimentId; }
            if (isStringNotEmpty(siteEvent.variantId)) { this.variantId = siteEvent.variantId; }
            if (isStringNotEmpty(siteEvent.assignmentKey)) { this.assignmentKey = siteEvent.assignmentKey; }

            if (isStringNotEmpty(siteEvent.eventKey)) { this.eventKey = siteEvent.eventKey; }
            if (isStringNotEmpty(siteEvent.eventCategory)) { this.eventCategory = siteEvent.eventCategory; }
            if (isStringNotEmpty(siteEvent.stageKey)) { this.stageKey = siteEvent.stageKey; }
            if (isStringNotEmpty(siteEvent.stepKey)) { this.stepKey = siteEvent.stepKey; }
            if (isStringNotEmpty(siteEvent.stepType)) { this.stepType = siteEvent.stepType; }
            if (isNumberNotEmpty(siteEvent.displayOrder)) { this.displayOrder = siteEvent.displayOrder; }

            if (isStringNotEmpty(siteEvent.sessionKey)) { this.sessionKey = siteEvent.sessionKey; }
            if (isStringNotEmpty(siteEvent.encounterId)) { this.encounterId = siteEvent.encounterId; }
            if (isStringNotEmpty(siteEvent.subscriptionId)) { this.subscriptionId = siteEvent.subscriptionId; }
            if (isStringNotEmpty(siteEvent.orderId)) { this.orderId = siteEvent.orderId; }

            if (isStringNotEmpty(siteEvent.surveyId)) { this.surveyId = siteEvent.surveyId; }
            if (isStringNotEmpty(siteEvent.surveySlug)) { this.surveySlug = siteEvent.surveySlug; }
            if (isStringNotEmpty(siteEvent.surveyStepId)) { this.surveyStepId = siteEvent.surveyStepId; }
            if (isStringNotEmpty(siteEvent.surveyStepKey)) { this.surveyStepKey = siteEvent.surveyStepKey; }
            if (isListNotEmpty(siteEvent.questionIds)) { this.questionIds = siteEvent.questionIds; }
            if (isListNotEmpty(siteEvent.branchPath)) { this.branchPath = siteEvent.branchPath; }
            if (isStringNotEmpty(siteEvent.conditionalVisibility)) { this.conditionalVisibility = siteEvent.conditionalVisibility; }

            if (isStringNotEmpty(siteEvent.result)) { this.result = siteEvent.result; }
            if (isStringNotEmpty(siteEvent.blockerCode)) { this.blockerCode = siteEvent.blockerCode; }
            if (isStringNotEmpty(siteEvent.dataQuality)) { this.dataQuality = siteEvent.dataQuality; }

            if (isStringNotEmpty(siteEvent.entryProductSku)) { this.entryProductSku = siteEvent.entryProductSku; }
            if (isStringNotEmpty(siteEvent.entryOfferGroupId)) { this.entryOfferGroupId = siteEvent.entryOfferGroupId; }
            if (isStringNotEmpty(siteEvent.entryOfferToken)) { this.entryOfferToken = siteEvent.entryOfferToken; }
            if (isStringNotEmpty(siteEvent.firstProductSkuSelected)) { this.firstProductSkuSelected = siteEvent.firstProductSkuSelected; }
            if (isStringNotEmpty(siteEvent.firstOfferGroupIdSelected)) { this.firstOfferGroupIdSelected = siteEvent.firstOfferGroupIdSelected; }
            if (isStringNotEmpty(siteEvent.firstOfferTokenSelected)) { this.firstOfferTokenSelected = siteEvent.firstOfferTokenSelected; }
            if (isStringNotEmpty(siteEvent.finalProductSkuSelected)) { this.finalProductSkuSelected = siteEvent.finalProductSkuSelected; }
            if (isStringNotEmpty(siteEvent.finalOfferGroupIdSelected)) { this.finalOfferGroupIdSelected = siteEvent.finalOfferGroupIdSelected; }
            if (isStringNotEmpty(siteEvent.finalOfferTokenSelected)) { this.finalOfferTokenSelected = siteEvent.finalOfferTokenSelected; }
            if (isStringNotEmpty(siteEvent.checkoutProductSku)) { this.checkoutProductSku = siteEvent.checkoutProductSku; }
            if (isStringNotEmpty(siteEvent.checkoutOfferGroupId)) { this.checkoutOfferGroupId = siteEvent.checkoutOfferGroupId; }
            if (isStringNotEmpty(siteEvent.checkoutOfferToken)) { this.checkoutOfferToken = siteEvent.checkoutOfferToken; }

            if (isBooleanTrue(siteEvent.isExistingCustomer)) { this.isExistingCustomer = true; }
            if (isBooleanTrue(siteEvent.phoneVerificationRequired)) { this.phoneVerificationRequired = true; }
            if (isBooleanTrue(siteEvent.governmentIdRequired)) { this.governmentIdRequired = true; }
            if (isBooleanTrue(siteEvent.governmentIdReused)) { this.governmentIdReused = true; }
            if (isBooleanTrue(siteEvent.identityConfirmationRequired)) { this.identityConfirmationRequired = true; }

            if (isNotNullOrUndefined(siteEvent.occurredAt)) { this.occurredAt = siteEvent.occurredAt; }

            // stamp the monotonic client clock at fire time; honor a value captured upstream
            // (queued events stamp at enqueue), otherwise read it now for immediately-fired events.
            // never compute this server-side - it is a client-only duration
            if (isNotNullOrUndefined(siteEvent.perfNowMs)) { this.perfNowMs = siteEvent.perfNowMs; }
            else if (typeof performance !== 'undefined') { this.perfNowMs = Math.round(performance.now()); }
        }
    }

    toDto = () => {
        return {
            funnel: this.funnel,
            stepNumber: this.stepNumber,
            stepName: this.stepName,
            direction: this.direction,
            eventName: this.eventName,
            pathName: this.pathName,

            offerId: this.offerId,
            affId: this.affId,
            sub1: this.sub1,
            sub2: this.sub2,
            sub3: this.sub3,
            sub4: this.sub4,
            sub5: this.sub5,
            uId: this.uId,
            sourceId: this.sourceId,
            transactionId: this.transactionId,
            source: this.source,
            affiliateId: this.affiliateId,
            subAffiliateId: this.subAffiliateId,
            campaignId: this.campaignId,
            programId: this.programId,
            version: this.version,
            creativeId: this.creativeId,
            clickId: this.clickId,
            ipAddress: this.ipAddress,
            userAgent: this.userAgent,
            referrerUrl: this.referrerUrl,
            visitorId: this.visitorId,
            landingRouteAlias: this.landingRouteAlias,
            userId: this.userId,
            leadId: this.leadId,

            shippingState: this.shippingState,
            gender: this.gender,
            dateOfBirth: this.dateOfBirth,
            bmi: this.bmi,

            couponCode: this.couponCode,

            siteVisitId: this.siteVisitId,

            testMode: this.testMode,

            url: this.url,

            fbclid: this.fbclid,
            fbc: this.fbc,
            ttclid: this.ttclid,
            gclid: this.gclid,
            irclickid: this.irclickid,
            rdt_cid: this.rdt_cid,
            SsCid: this.SsCid,
            msclkid: this.msclkid,
            twclid: this.twclid,
            nbclid: this.nbclid,
            gbraid: this.gbraid,
            wbraid: this.wbraid,

            utm_source: this.utm_source,
            utm_campaign: this.utm_campaign,
            utm_content: this.utm_content,
            utm_medium: this.utm_medium,
            utm_term: this.utm_term,

            productSku: this.productSku,
            offerGroupId: this.offerGroupId,
            offerToken: this.offerToken,
            addon: this.addon,
            deviceFingerprint: this.deviceFingerprint,
            amount: this.amount,

            funnelType: this.funnelType,
            funnelKey: this.funnelKey,
            funnelVersion: this.funnelVersion,
            funnelConfigId: this.funnelConfigId,
            experimentId: this.experimentId,
            variantId: this.variantId,
            assignmentKey: this.assignmentKey,

            eventKey: this.eventKey,
            eventCategory: this.eventCategory,
            stageKey: this.stageKey,
            stepKey: this.stepKey,
            stepType: this.stepType,
            displayOrder: this.displayOrder,

            sessionKey: this.sessionKey,
            encounterId: this.encounterId,
            subscriptionId: this.subscriptionId,
            orderId: this.orderId,

            surveyId: this.surveyId,
            surveySlug: this.surveySlug,
            surveyStepId: this.surveyStepId,
            surveyStepKey: this.surveyStepKey,
            questionIds: this.questionIds,
            branchPath: this.branchPath,
            conditionalVisibility: this.conditionalVisibility,

            result: this.result,
            blockerCode: this.blockerCode,
            dataQuality: this.dataQuality,

            entryProductSku: this.entryProductSku,
            entryOfferGroupId: this.entryOfferGroupId,
            entryOfferToken: this.entryOfferToken,
            firstProductSkuSelected: this.firstProductSkuSelected,
            firstOfferGroupIdSelected: this.firstOfferGroupIdSelected,
            firstOfferTokenSelected: this.firstOfferTokenSelected,
            finalProductSkuSelected: this.finalProductSkuSelected,
            finalOfferGroupIdSelected: this.finalOfferGroupIdSelected,
            finalOfferTokenSelected: this.finalOfferTokenSelected,
            checkoutProductSku: this.checkoutProductSku,
            checkoutOfferGroupId: this.checkoutOfferGroupId,
            checkoutOfferToken: this.checkoutOfferToken,

            isExistingCustomer: this.isExistingCustomer,
            phoneVerificationRequired: this.phoneVerificationRequired,
            governmentIdRequired: this.governmentIdRequired,
            governmentIdReused: this.governmentIdReused,
            identityConfirmationRequired: this.identityConfirmationRequired,

            occurredAt: this.occurredAt,
            perfNowMs: this.perfNowMs
        };
    }

    static sendFcmNotification = async (deviceToken, title, body) => {
        try {
            const { getMessaging } = await import("firebase/messaging");
            const messaging = getMessaging();

            const message = {
                notification: {
                    title: title,
                    body: body
                },
                token: deviceToken
            };

            const response = await messaging.send(message);
            logger.logDebugEvent('SITE_EVENT_FCM', `Successfully sent FCM notification: ${JSON.stringify(response)}`, getTestModeConsole());
            return response;
        } catch (error) {
            logger.logErrorEvent('SITE_EVENT_FCM', error, 'Error sending FCM notification', getTestModeConsole());
            throw error;
        }
    }

    create = async () => {
        // console.log('Creating new site event', this.toDto());
        if (this.affiliateId === 'evr' && isStringEmpty(this.transactionId)) {
            this.transactionId = getQueryParam(this.url, '_ef_transaction_id') || getQueryParam(this.url, 'transaction_id') || getQueryParam(this.referrerUrl, '_ef_transaction_id') || getQueryParam(this.referrerUrl, 'transaction_id') || null;
        }
        let newSiteEvent = await create(SiteEvent.collectionName, this.toDto());
        if (isObjectNotEmpty(newSiteEvent)) {
            // console.log('Created new site event: ', newSiteEvent.funnel, newSiteEvent.stepNumber, newSiteEvent.stepName, newSiteEvent.direction, newSiteEvent.eventName);
            try {
                if (newSiteEvent?.eventName?.includes('_hipaa_3')) {
                    const newNotification = await new Notification({
                        toStaff: true,

                        subject: "Lead fired " + newSiteEvent?.eventName,
                        body: "A lead has fired event " + newSiteEvent?.eventName,
                        type: 'SUCCESS',
                        severity: 'HIGH',

                        entityType: 'Lead',
                        entityId: newSiteEvent?.leadId,
                        entityStatus: newSiteEvent?.eventName?.includes('_hipaa_3') ? 'CC_AUTH' : 'CONVERTED',

                        eventType: newSiteEvent?.eventName?.includes('_hipaa_3') ? 'LEAD_CC_AUTH' : 'LEAD_CONVERTED',

                        read: false,
                        readAt: null,

                        cta: { url: ROUTES.MANAGE_LEADS, label: 'Manage Leads' }
                    }).create();
                    if (isObjectNotEmpty(newNotification)) {
                        try {
                            await sendFCMMessage({
                                topic: 'corpstaff',
                                notification: {
                                    title: "Lead fired " + newSiteEvent?.eventName,
                                    body: "A lead has fired event " + newSiteEvent?.eventName
                                },
                                data: {
                                    notificationId: newNotification?.id,
                                    url: "https://admin.readyrx.com" + ROUTES.MANAGE_LEADS,
                                    label: 'Manage Leads',
                                    id: newNotification?.id,

                                    subject: "Lead fired " + newSiteEvent?.eventName,
                                    body: "A lead has fired event " + newSiteEvent?.eventName,
                                    type: 'SUCCESS',
                                    severity: 'HIGH',

                                    entityType: 'Lead',
                                    entityId: newSiteEvent?.leadId,
                                    entityStatus: newSiteEvent?.eventName?.includes('_hipaa_3') ? 'CC_AUTH' : 'CONVERTED',

                                    eventType: newSiteEvent?.eventName?.includes('_hipaa_3') ? 'LEAD_CC_AUTH' : 'LEAD_CONVERTED'
                                }
                                // webpush: {
                                //     headers: {
                                //         Urgency: "high"
                                //     },
                                //     fcm_options: {
                                //         link: "https://app.readyrx.com" + ROUTES.MANAGE_LEADS
                                //     }
                                // }
                            });
                        } catch (err) {
                            logger.logErrorEvent('SITE_EVENT_HIPAA3_NOTIFICATION', err, 'Error firing hipaa_3 staff notification', getTestModeConsole());
                        }
                    }
                }
            } catch (err) {
                logger.logErrorEvent('SITE_EVENT_HIPAA3_NOTIFICATION', err, 'Error firing hipaa_3 staff notification', getTestModeConsole());
            }

            // console.log(newSiteEvent?.stepName, newSiteEvent?.pathName);
            try {
                window.dataLayer.push({
                    gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID,
                    event: newSiteEvent?.eventName,
                    page: newSiteEvent?.pathName,
                    offerId: newSiteEvent?.offerId,
                    affId: newSiteEvent?.affId,
                    sub1: newSiteEvent?.sub1,
                    sub2: newSiteEvent?.sub2,
                    sub3: newSiteEvent?.sub3,
                    sub4: newSiteEvent?.sub4,
                    sub5: newSiteEvent?.sub5,
                    uId: newSiteEvent?.uId,
                    sourceId: newSiteEvent?.sourceId,
                    transactionId: newSiteEvent?.transactionId,
                    source: newSiteEvent?.source,
                    affiliateId: newSiteEvent?.affiliateId,
                    subAffiliateId: newSiteEvent?.subAffiliateId,
                    version: newSiteEvent?.version,
                    creativeId: newSiteEvent?.creativeId,
                    clickId: newSiteEvent?.clickId,
                    ipAddress: newSiteEvent?.ipAddress,
                    userAgent: newSiteEvent?.userAgent,
                    referrerUrl: newSiteEvent?.referrerUrl,
                    userId: newSiteEvent?.userId,
                    leadId: newSiteEvent?.leadId,

                    couponCode: newSiteEvent?.couponCode,

                    shippingState: newSiteEvent?.shippingState,
                    gender: newSiteEvent?.gender,
                    dateOfBirth: newSiteEvent?.dateOfBirth,

                    siteVisitId: newSiteEvent?.siteVisitId,

                    testMode: newSiteEvent?.testMode,

                    url: newSiteEvent?.url,

                    fbclid: newSiteEvent?.fbclid,
                    fbc: newSiteEvent?.fbc,
                    ttclid: newSiteEvent?.ttclid,
                    gclid: newSiteEvent?.gclid,
                    irclickid: newSiteEvent?.irclickid,
                    rdt_cid: newSiteEvent?.rdt_cid,
                    SsCid: newSiteEvent?.SsCid,
                    msclkid: newSiteEvent?.msclkid,
                    twclid: newSiteEvent?.twclid,
                    nbclid: newSiteEvent?.nbclid,
                    gbraid: newSiteEvent?.gbraid,
                    wbraid: newSiteEvent?.wbraid,

                    utm_source: newSiteEvent?.utm_source,
                    utm_campaign: newSiteEvent?.utm_campaign,
                    utm_content: newSiteEvent?.utm_content,
                    utm_medium: newSiteEvent?.utm_medium,
                    utm_term: newSiteEvent?.utm_term,

                    addon: newSiteEvent?.addon,
                    deviceFingerprint: newSiteEvent?.deviceFingerprint,

                    funnel: newSiteEvent?.funnel,
                    stepNumber: newSiteEvent?.stepNumber,
                    stepName: newSiteEvent?.stepName,
                    direction: newSiteEvent?.direction === 'submitted' ? 'f' : (newSiteEvent?.direction === 'back' ? 'b' : null),

                    productSku: newSiteEvent?.productSku ?? null,
                    amount: newSiteEvent?.amount ?? 0
                });

                if (newSiteEvent?.testMode === true) {
                    logger.logDebugEvent('SITE_EVENT_DATALAYER_PUSH', `Pushed event to dataLayer: ${JSON.stringify(newSiteEvent)}`, true);
                }

                LogRocket.track(newSiteEvent?.eventName, sanitizeTrackProperties(removeEmptyAndNull({
                    ...newSiteEvent,
                    createdAt: fromUtcToDate(newSiteEvent.createdAt),
                    modifiedAt: fromUtcToDate(newSiteEvent.createdAt)
                })));
            } catch (err) {
                logger.logErrorEvent('SITE_EVENT_DATALAYER_PUSH', err, 'Failed to add event to dataLayer', getTestModeConsole());
            }
        }

        return newSiteEvent;
    }

    static updateField = async (id, fieldName, newValue) => {
        if (isStringNotEmpty(id)) {
            return await updateField(SiteEvent.collectionName, id, fieldName, newValue);
        } else {
            throw new Error("id is required.");
        }
    }

    static updateFields = async (id, updatedFields) => {
        if (isStringNotEmpty(id)) {
            return await updateFields(SiteEvent.collectionName, id, updatedFields);
        } else {
            throw new Error("id is required.");
        }
    }

    static update = async (id, updatedSiteVisit, oldObj) => {
        const updatedObj = new SiteEvent(updatedSiteVisit);
        if (id === updatedSiteVisit.id) {
            const success = await update(SiteEvent.collectionName, id, updatedObj.toDto());
            if (isBooleanTrue(success)) {
                return { ...oldObj, ...updatedObj };
            }
        } else {
            throw new Error('id and id field of the updated site visit must match.')
        }

        return null;
    }

    static delete = async (id) => {
        if (isStringNotEmpty(id)) {
            return await remove(SiteEvent.collectionName, id);
        } else {
            throw new Error("id is required.");
        }
    }

    static getAll = async () => {
        return await getAll(SiteEvent.collectionName);
    }

    static getByField = async (fieldName, fieldValue, comparer = '==') => {
        return await getBySingleQuery(SiteEvent.collectionName, fieldName, fieldValue, comparer);
    }

    static getBySiteVisitId = async (siteVisitId) => {
        if (isStringNotEmpty(siteVisitId)) {
            const list = await getBySingleQuery(SiteEvent.collectionName, 'siteVisitId', siteVisitId, '==');
            return lodashOrderBy(list, [(siteEvent) => fromUtcToDate(siteEvent.createdAt)], ['asc']);
        }

        return [];
    }

    static getCount = async (queryParameters) => {
        const { affiliateId, subAffiliateId, direction, start, end, testMode, eventName, eventKey, funnel, stepNumber, stepName, leadId, siteVisitId } = queryParameters;

        let queryConstraints = [];

        if (isListNotEmpty(affiliateId)) {
            queryConstraints.push(where('affiliateId', 'in', toLower(affiliateId)));
        } else if (isStringNotEmptyOrZeroLength(affiliateId)) {
            queryConstraints.push(where('affiliateId', '==', toLower(affiliateId)));
        }

        if (isListNotEmpty(subAffiliateId)) {
            queryConstraints.push(where('subAffiliateId', 'in', subAffiliateId));
        } else if (isStringNotEmptyOrZeroLength(subAffiliateId)) {
            queryConstraints.push(where('subAffiliateId', '==', subAffiliateId));
        }

        if (isListNotEmpty(direction)) {
            queryConstraints.push(where('direction', 'in', direction));
        } else if (isStringNotEmptyOrZeroLength(direction)) {
            queryConstraints.push(where('direction', '==', direction));
        }

        if (isListNotEmpty(eventName)) {
            queryConstraints.push(where('eventName', 'in', eventName));
        } else if (isStringNotEmptyOrZeroLength(eventName)) {
            queryConstraints.push(where('eventName', '==', eventName));
        }

        if (isListNotEmpty(eventKey)) {
            queryConstraints.push(where('eventKey', 'in', eventKey));
        } else if (isStringNotEmptyOrZeroLength(eventKey)) {
            queryConstraints.push(where('eventKey', '==', eventKey));
        }

        if (isListNotEmpty(funnel)) {
            queryConstraints.push(where('funnel', 'in', funnel));
        } else if (isStringNotEmptyOrZeroLength(funnel)) {
            queryConstraints.push(where('funnel', '==', funnel));
        }

        if (isListNotEmpty(stepNumber)) {
            queryConstraints.push(where('stepNumber', 'in', stepNumber));
        } else if (isNotNullOrUndefined(stepNumber)) {
            queryConstraints.push(where('stepNumber', '==', stepNumber));
        }

        if (isListNotEmpty(stepName)) {
            queryConstraints.push(where('stepName', 'in', stepName));
        } else if (isNotNullOrUndefined(stepName)) {
            queryConstraints.push(where('stepName', '==', stepName));
        }

        if (isListNotEmpty(leadId)) {
            queryConstraints.push(where('leadId', 'in', leadId));
        } else if (isStringNotEmptyOrZeroLength(leadId)) {
            queryConstraints.push(where('leadId', '==', leadId));
        }

        if (isListNotEmpty(siteVisitId)) {
            queryConstraints.push(where('siteVisitId', 'in', siteVisitId));
        } else if (isStringNotEmptyOrZeroLength(siteVisitId)) {
            queryConstraints.push(where('siteVisitId', '==', siteVisitId));
        }

        if (isBooleanTrue(testMode)) {
            queryConstraints.push(where('testMode', '==', true));
        } else if (isBooleanFalse(testMode)) {
            queryConstraints.push(where('testMode', '==', false));
        }

        if (isNotNullOrUndefined(start)) {
            let startDate = asTimeZone(moment(new Date(start)), 'US/Pacific').startOf('day').utc().toDate();
            queryConstraints.push(where('createdAt', '>=', startDate));
        }

        if (isNotNullOrUndefined(end)) {
            let endDate = asTimeZone(moment(new Date(end)), 'US/Pacific').endOf('day').utc().toDate();
            queryConstraints.push(where('createdAt', '<=', endDate));
        }

        let q = query(collection(db, SiteEvent.collectionName), ...queryConstraints);

        const snapShot = await getCountFromServer(q);

        //console.log(snapShot.data());

        return snapShot.data().count;
    }

    static getPaginated = async (queryParameters, pageSize = 25, firstVisible, lastVisible, orderByField = 'createdAt') => {
        const { affiliateId, subAffiliateId, direction, start, end, testMode, eventName, funnel, stepNumber, stepName } = queryParameters;

        let queryConstraints = [];

        if (isListNotEmpty(affiliateId)) {
            queryConstraints.push(where('affiliateId', 'in', toLower(affiliateId)));
        } else if (isStringNotEmptyOrZeroLength(affiliateId)) {
            queryConstraints.push(where('affiliateId', '==', toLower(affiliateId)));
        }

        if (isListNotEmpty(subAffiliateId)) {
            queryConstraints.push(where('subAffiliateId', 'in', subAffiliateId));
        } else if (isStringNotEmptyOrZeroLength(subAffiliateId)) {
            queryConstraints.push(where('subAffiliateId', '==', subAffiliateId));
        }

        if (isListNotEmpty(direction)) {
            queryConstraints.push(where('direction', 'in', direction));
        } else if (isStringNotEmptyOrZeroLength(direction)) {
            queryConstraints.push(where('direction', '==', direction));
        }

        if (isListNotEmpty(eventName)) {
            queryConstraints.push(where('eventName', 'in', eventName));
        } else if (isStringNotEmptyOrZeroLength(eventName)) {
            queryConstraints.push(where('eventName', '==', eventName));
        }

        if (isListNotEmpty(funnel)) {
            queryConstraints.push(where('funnel', 'in', funnel));
        } else if (isStringNotEmptyOrZeroLength(funnel)) {
            queryConstraints.push(where('funnel', '==', funnel));
        }

        if (isListNotEmpty(stepNumber)) {
            queryConstraints.push(where('stepNumber', 'in', stepNumber));
        } else if (isNotNullOrUndefined(stepNumber)) {
            queryConstraints.push(where('stepNumber', '==', stepNumber));
        }

        if (isListNotEmpty(stepName)) {
            queryConstraints.push(where('stepName', 'in', stepName));
        } else if (isNotNullOrUndefined(stepName)) {
            queryConstraints.push(where('stepName', '==', stepName));
        }

        if (isBooleanTrue(testMode)) {
            queryConstraints.push(where('testMode', '==', true));
        } else if (isBooleanFalse(testMode)) {
            queryConstraints.push(where('testMode', '==', false));
        }

        if (isNotNullOrUndefined(start)) {
            let startDate = asTimeZone(moment(new Date(start)), 'US/Pacific').startOf('day').utc().toDate();
            queryConstraints.push(where('createdAt', '>=', startDate));
        }

        if (isNotNullOrUndefined(end)) {
            let endDate = asTimeZone(moment(new Date(end)), 'US/Pacific').endOf('day').utc().toDate();
            queryConstraints.push(where('createdAt', '<=', endDate));
        }

        let q = null;
        if (isObjectNotEmpty(firstVisible)) {
            q = query(collection(db, SiteEvent.collectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limitToLast(pageSize), endBefore(firstVisible[orderByField], firstVisible['id']));
        } else if (isObjectNotEmpty(lastVisible)) {
            q = query(collection(db, SiteEvent.collectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limit(pageSize), startAfter(lastVisible[orderByField], lastVisible['id']));
        } else {
            q = query(collection(db, SiteEvent.collectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limit(pageSize));
        }

        let snapShot = await getDocs(q);
        return snapShot.docs.map((doc) => {
            return {
                id: doc.id,
                ...doc.data()
            };
        });
    }

    static get = async (queryParameters) => {
        // console.log('queryParameters', queryParameters);
        let allRecords = [];
        try {
            let next = null;
            let totalPages = 0;

            let totalCount = await this.getCount(queryParameters);
            totalPages = Math.ceil(totalCount / 10000.0);
            // console.log('totalCount: ' + totalCount);
            // console.log('totalPages: ' + totalPages);
            let pages = [];
            for (let i = 0; i < totalPages; i++) {
                pages.push(i + 1);
            }
            for (const page of pages) {
                // console.log('starting page ' + page);

                let list = await this.getPaginated(queryParameters, 10000, null, next, 'createdAt');

                // console.log(list.length);
                allRecords = [...allRecords, ...list];

                // console.log(allRecords.length);

                // console.log('go to next page');
                next = list[list.length - 1];
            }
        } catch (error) {
            logger.logErrorEvent('SITE_EVENT_PAGINATED', error, 'Error paginating site events', getTestModeConsole());
        }

        return allRecords;
    }
};

export default SiteEvent;
